import { useEnrollmentContext } from "@/state";
import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { CSSProperties, FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelectedEnrollmentPlan } from "../hooks";
import "./NeedHelp.scss";

export const NeedHelp: FC = () => {
  const experienceData = useEnrollmentContext();
  const fontStyle: CSSProperties = {
    fontFamily: ((experienceData?.theme as { font?: string } | undefined)?.font || "Source Sans 3"),
  };
  const { customerServicePhoneNumber } = useSelectedEnrollmentPlan();
  const { t: translate } = useTranslation();

  if (customerServicePhoneNumber) {
    return (
      <Shelf className="need-help-shelf">
        <Shelf.Spacer />
        <Shelf>
          {experienceData.experience.identifier.toLowerCase() !== "l3harris" && (
            <>
              <Icon className="need-help-icon" color="lightgrey" size="regular" name="phone" />
              <p className="need-help-text" style={fontStyle}>
                {translate("NEED_HELP.contactUs")} {customerServicePhoneNumber}
              </p>
            </>
          )}
        </Shelf>
        <Shelf.Spacer />
      </Shelf>
    );
  } else {
    return <></>;
  }
};
